<div class="cov-asm-impersonate-user-information">
  <div class="large-mode">
    <div class="d-flex gap-2 mb-2 align-items-center">
      <cov-icon [iconName]="IconName.BLACK_USER" class="user-icon"></cov-icon>

      {{
            'asm.impersonateStatus.activeSessionText'
              | transloco
                : {
                    impersonatedUser: impersonatedUser()?.fullName,
                    asmUser: asmUser()?.agent?.firstName,
                  }
      }}
    </div>
    <cov-button [buttonType]="ButtonType.SECONDARY" (click)="endSession()">
      <cov-icon [iconName]="IconName.LOGOUT"></cov-icon>
      <span class="btn-text">{{
            'asm.sessionManagement.buttons.endImpersonation' | transloco
      }}</span>
    </cov-button>
  </div>
  <div class="collapsed-mode">
    <cov-icon
      [iconName]="IconName.INFO_CIRCLE"
      class="info-icon"
      role="button"
      tabindex="0"
      [attr.aria-label]="'asm.impersonateStatus.activeSessionText' | transloco: { impersonatedUser: impersonatedUser()?.fullName, asmUser: asmUser()?.agent?.firstName }"
      [attr.aria-expanded]="infoVisible()"
      aria-controls="impersonated-info-panel"
      (click)="toggleImpersonatedInfo()"
      (keydown.enter)="toggleImpersonatedInfo()"
      (keydown.space)="toggleImpersonatedInfo()"
      (keydown.escape)="infoVisible.set(false)"
    ></cov-icon>
    <div class="asm-text">{{ 'navbar.asm' | transloco }}</div>
    <button
      class="end-session"
      [attr.aria-label]="'asm.sessionManagement.buttons.endImpersonation' | transloco"
      (click)="endSession()"
    >
      <cov-icon [iconName]="IconName.LOGOUT" class="icon"></cov-icon>
    </button>

    @if (infoVisible()) {
      <div class="impersonated-info" id="impersonated-info-panel">
        {{
              'asm.impersonateStatus.activeSessionText'
                | transloco
                  : {
                      impersonatedUser: impersonatedUser()?.fullName,
                      asmUser: asmUser()?.agent?.firstName,
                    }
        }}
      </div>
    }
  </div>
</div>
